import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../filter/FilterButton'

const FilterButtonUser = () => {
  const open = useSelector(state => state?.filter?.user?.open || false)

  return (
    <>
      <FilterButton 
        module='user' 
        keysFilter={['yearLevelId', 'rolesId', 'flagId']} 
        keepReload={false}
      />
      { open &&
        <FilterDialog />
      }
    </>
  )
}
export default FilterButtonUser